import { replaceURL } from "./replaceURL";
import { getBaseURL } from './getBaseURL'

export default function WPApiFetch(route, target=null, method="GET", body=null, credentials="omit", nonce=null, signal=null) {
	const baseURL = getBaseURL();
	let Headers = {}	

	if(nonce) {
		Headers['X-WP-Nonce'] = nonce;
		credentials = 'include';
	}
	const restUrl = baseURL+'/wp-json'+route
	const Method = method
	let devURL = '';
	if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
		const delimiter = (restUrl.includes('?')) ? "&" : "?";
		devURL = delimiter+'dev=true';
	}

	return fetch(restUrl+devURL, { method:Method, credentials:credentials, headers:Headers, body:body, signal:signal } )
		.then(async response => {

			const data = await response.json();
			if (!response.ok) {
				switch(response.status) {
					case 401: 
						break;
					case 403: 
						break;
					default: 
						break;
				}

				const error = (data && data.message) || response.statusText;
				return Promise.reject(error);
			}
			if(data.redirect) {
				const url = replaceURL(data.redirect);
				if(target) { target.props.history.push(url); }
				return Promise.reject(null);
			}
			if(data.reload) {
				const url = replaceURL(data.reload);
				window.location.href = url;
				return Promise.reject(null);
			}
			data['total'] = response.headers.get('x-wp-total');
			data['totalpages'] = response.headers.get('x-wp-totalpages');
			data['nonce'] = response.headers.get('x-wp-nonce');

			return Promise.resolve(data);
	  	})
		.catch( error => {
			if(target) {
				target.setState({error: error});
			} else {
				throw(error);
			}
			return Promise.reject(error);
		});
}


/***********************************************************/

export function GetGenres() {
	const Url = global.config.baseURL+'/wp-json/wp/v2/genre?per_page=100'
	const Method = 'GET'
	const Credentials = 'omit'
	const Headers = {}
	return fetch(Url, { method:Method, credentials:Credentials, headers:Headers } )
	.then(async response => {
		const data = await response.json();
		if (!response.ok) {
			const error = (data && data.message) || response.statusText;
			return Promise.reject(error);
		}
		if( data.length === 0) {
			const error = 'empty response';
			return Promise.reject(error);
		}
		return Promise.resolve(data);
  	}).then(data => {
  		let genres = {}
  		data.map(item=> { genres[item.slug] = item; return null; })
  		localStorage.setItem('genres', JSON.stringify(genres));
  		return genres;
  		//this.setState({genre: genres[genre_slug]});
		//this.loadProducts(genres[genre_slug].id);
  	})
	.catch( error => {
		//this.setState({error: true});
		return Promise.reject(error);
	});
}

export function LoadTerms(taxonomy, terms) {
	const Url = global.config.baseURL+'/wp-json/wp/v2/'+taxonomy+'?hide_empty=true&per_page=100'
	console.log(Url);
	const Method = 'GET'
	const Credentials = 'omit'
	const Headers = {}
	return fetch(Url, { method:Method, credentials:Credentials, headers:Headers } )
	.then(async response => {
		const data = await response.json();
		console.log(data);
		if (!response.ok) {
			const error = (data && data.message) || response.statusText;
			return Promise.reject(error);
		}
		if( data.length === 0) {
			const error = 'empty response';
			return Promise.reject(error);
		}
		return Promise.resolve(data);
  	}).then(data => {
  		let terms = {}
  		data.map(item=> { terms[item.slug] = item; return null; })
  		localStorage.setItem(taxonomy, JSON.stringify(terms));
  		return terms;
  	})
	.catch( error => {
		return Promise.reject(error);
	});
}

export function LoadTerm(taxonomy, term) {
	const Url = global.config.baseURL+'/wp-json/wp/v2/'+taxonomy+'?slug='+term
	const Method = 'GET'
	const Credentials = 'omit'
	const Headers = {}
	
	const terms = localStorage.getItem(taxonomy) === null ? {} : JSON.parse( localStorage.getItem(taxonomy) );
	if(terms[term]) {
		return terms[term]
	}

	return fetch(Url, { method:Method, credentials:Credentials, headers:Headers } )
	.then(async response => {
		const data = await response.json();
		if (!response.ok) {
			const error = (data && data.message) || response.statusText;
			return Promise.reject(error);
		}
		if( data.length === 0) {
			const error = 'empty response';
			return Promise.reject(error);
		}
		return Promise.resolve(data);
  	}).then(data => {
  		data.map(item=> { terms[item.slug] = item; return null; })
  		localStorage.setItem(taxonomy, JSON.stringify(terms));
  		return terms[term];
  	})
	.catch( error => {
		return Promise.reject(error);
	});
}